import { render, staticRenderFns } from "./user-center-title.vue?vue&type=template&id=05a802f7&scoped=true"
import script from "./user-center-title.vue?vue&type=script&lang=js"
export * from "./user-center-title.vue?vue&type=script&lang=js"
import style0 from "./user-center-title.vue?vue&type=style&index=0&id=05a802f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a802f7",
  null
  
)

export default component.exports